import MyFooter      from '../../../views/layout-footer'
import Breadcrumb    from '../../../views/breadcrumb'
import GridGenerator from '../../../grids/grid-generator'
import ScrollToTop   from '../../../widgets/scroll-to-top'

export default {
  components: {
    MyFooter,
    GridGenerator,
    Breadcrumb,
    ScrollToTop
  },

  props: [
    'menuField',
    'row',
    'scrollFiredProp',
    'idStructure'
  ],

  data () {
    return {
      page:             this.$route.params.page,
      parsedFieldsData: [],
      breadcrumbItems:  [],
      innerMenuField:   {
        Field:             '',
        DictionaryKeyCode: '',
        WhereCondition:    ''
      },
      showPreloader:    true
    }
  },

  computed: {
    h1 () {
      return this.innerMenuField.DictionaryKeyCode
    },
    parentProp: {
      get: function () {
        return { def: this.def, data: { SEARCHTEXT: this.h1 } }
      }
    }
  },

  created () {
    this.innerMenuField = this.menuField ? this.menuField : {}
    this._setBreadcrumbs()
  },

  watch: {
    '$route': function (args) {
      this.page           = args.params.page
      this.innerMenuField = this.menuField
      this.showPreloader  = true

      this._setBreadcrumbs()
    }
  },

  methods: {

    /**
     *
     * @private
     */
    _setBreadcrumbs () {
      this.breadcrumbItems = []
      this.breadcrumbItems.push({ name: 'Dashboard', label: 'Home' })
      this.breadcrumbItems.push({ name: this.h1, label: this.h1, active: true })
    },

    /**
     *
     * @private
     */
    _dataLoadedListener () {
      this.showPreloader = false
    },

    /**
     *
     * @param def
     * @private
     */
    _defLoaded (def) {
      this.innerMenuField = def.response.data[0]
      this._setBreadcrumbs()
    }
  }

}
